import { loan_application } from '@axo/shared/data-access/types';

export function formatCurrency(
  amount: number | string | undefined | null,
  currency?: loan_application.Currency | null
): string {
  try {
    const formatter = Intl.NumberFormat('da-DK', {
      style: 'currency',
      currency: currency || 'EUR',
      maximumFractionDigits: 0,
    });

    const asNumber = Number(amount);

    if (isNaN(asNumber)) {
      return '-';
    }

    return formatter.format(asNumber);
  } catch {
    return amount?.toString() || '';
  }
}

export function currencyFormatter(
  currency?: loan_application.Currency | null | undefined
) {
  return function (amount: number | string | undefined | null) {
    return formatCurrency(amount, currency);
  };
}
